import React from "react";
import { IconButton } from "@mui/material";
import IconFav from "src/assets/images/heart-favorite.png";
import { getInitialsImage } from "src/helpers/helperFunctions";
import RenderText from "src/Components/Text/RenderText";
import TestIcon from "src/assets/images/website-images/test-icon.png";
import BloodIcon from "src/assets/images/website-images/blood-icon.png";
import CartIcon from "src/assets/images/website-images/addcart-image-new.png";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import PriceView from "src/Components/GlobalComponents/PriceView";

interface IObj {
  _id: string;
  name: string;
  description: string;
  image: string;
  regularPrice: number;
  salePrice: number;
  isLiked: boolean;
  prescriptionRequired: boolean;
  noOfTests: number;
  nameOftests: string[];
}

interface TestWhishListCardProps {
  data: IObj;
  heart_id?: string;
  button_id?: string;
  handleRemove: () => void;
}

const BoxIcon = ({ icon, title }: { icon: string; title: string }) => {
  return (
    <div className="flex gap-1 items-center">
      <div className="w-[15px] h-[15px]  border border-gray-400 rounded flex items-center justify-center">
        <img
          src={icon}
          alt="icon"
          className="max-w-[80%] max-h-[80%] object-contain"
        />
      </div>
      <RenderText className="font-Poppins-Regular font-size-12px text-[#333333]">
        {title}
      </RenderText>
    </div>
  );
};

const PackagesWishListCard = ({
  data,
  heart_id,
  button_id,
  handleRemove,
}: TestWhishListCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-all-light-2 px-[6px] 2xl:px-2 py-2 2xl:py-3 flex gap-1 2xl:gap-2 items-center">
      <FavoriteCoponent
        category="package"
        onLikeProduct={handleRemove}
        id={data?._id}
        liked={data?.isLiked}
        className="bg-transparent"
        isWhishList
      />
      <div className="flex flex-col gap-2 flex-1">
        <div className="flex gap-2 2xl:gap-3 w-full">
          <div className="max-w-[5vw] rounded-lg h-fit overflow-hidden">
            <img
              src={`${data.image || ""}`}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getInitialsImage(data.name, 112, 48, "#00443f");
              }}
              alt={data.name}
              className="aspect-square"
            />
          </div>
          <div className="w-[calc(100%-5vw-10px)] flex flex-col gap-1">
            <RenderText className="font-Montserrat-SemiBold font-size-20px whishlist-package-text-color">
              {data.name}
            </RenderText>
            <div className="flex flex-col gap-1">
              {data.nameOftests.slice(0, 2).map((test) => (
                <div className="flex gap-1 items-center w-full">
                  <div className="w-[12px] h-[12px] 2xl:w-[19px] 2xl:h-[19px] xl:w-[15px] xl:h-[15px] bg-[#00443F] rounded-full flex items-center justify-center">
                    <FontAwesomeIcon icon={faCheck} className="text-white font-size-11px" />
                  </div>
                  <p className="font-Poppins-Regular line-clamp-1 font-size-14px text-[#3B3B3B]">
                    {test}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex w-full gap-2 justify-between">
          <PriceView
            salePrice={data?.salePrice || null}
            regularPrice={data?.regularPrice || 0}
            className="!font-Poppins-SemiBold"
            regularClassName="text-[#434343] font-size-15px-important"
            saleClassName="!text-[#202020] font-size-20px-important"
          />
          <AddCartButton
            id={button_id}
            productId={data?._id}
            type="diagnostic"
            itemType="package"
          />
        </div>
      </div>
    </div>
  );
};

export default PackagesWishListCard;
